module.exports = __webpack_public_path__ + "../resources/img/ic_incomplete_number_5.062f3979.svg";